<template>
    <div>
        {{ vatOptionCode }}
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {findValidVatOptionFromId, useVatService} from '@/vat/vat.service'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'

const props = defineProps({
    params: {required: true, type: Object as () => { data: BookkeepingAccount}}
})

const {vatOptions} = useVatService()

const bookkeepingAccount = computed(() => {
    return props.params.data
})

const vatOptionCode = computed(() => {
    const vatOption = findValidVatOptionFromId(vatOptions.value, bookkeepingAccount.value.vatSuggestionId)
    return vatOption?.code
})


</script>

<style>

</style>